/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      const isReduced = window.matchMedia( `(prefers-reduced-motion: reduce)` ) === true || window.matchMedia( `(prefers-reduced-motion: reduce)` ).matches === true;

      const hash = window.location.hash;

      if ( hash ) {
        const targetHash = hash;

        $( window ).on( 'load', () => {
          window.scrollTo( 0, 0 );
          const cleanUrl = window.location.pathname + window.location.search;
          history.replaceState( null, document.title, cleanUrl );

          const targetElement = $( targetHash );

          if ( targetElement.length ) {
            const navbarHeight = $( '.navbar' ).length ? $( '.navbar' ).outerHeight() : 0;
            const jumpLinkBannerHeight = $( '.jump-link-banner' ).length ? $( '.jump-link-banner' ).outerHeight() : 0;
            const totalOffset = navbarHeight + jumpLinkBannerHeight;

            $( 'html, body' ).animate( {
              scrollTop: targetElement.offset().top - totalOffset - 100,
            } );

            // restore the hash after scrolling
            history.replaceState( null, document.title, targetHash );
          }
        } );
      }

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        if ( $( 'body' ).hasClass( 'overflow-hidden' ) ) {
          $( 'body' ).removeClass( 'overflow-hidden' );
        } else {
          $( 'body' ).addClass( 'overflow-hidden' );
        }

        if ( !isReduced ) {
          $( '.primary-nav' ).slideToggle();
        }
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        if ( !isReduced ) {
          $( target ).slideToggle();
        }
      } );

      $( window ).on( 'resize', function() {
        const activeItemExists = $( '.primary-menu-item.is-active' ).length > 0;
        const hasRadioGroup = $( '.primary-menu-item[data-toggle-radio-group]' ).length > 0;

        if ( window.innerWidth >= 768 && typeof hasRadioGroup === 'undefined' ) {
          $( '.primary-menu-item' ).each( function() {
            $( this ).removeAttr( 'data-toggle-group' );
            $( this ).attr( 'data-toggle-radio-group', '' );
          } );

          if ( !activeItemExists ) {
            $( '.primary-menu-item' ).first().attr( 'data-toggle-is-active', '' );
            window.easyToggleState();
          }
        } else {
          if ( typeof hasRadioGroup !== 'undefined' ) {
            $( '.primary-menu-item' ).each( function() {
              $( this ).removeAttr( 'data-toggle-radio-group' );
              $( this ).attr( 'data-toggle-group', '' );
            } );
          }
        }

        const activeItem = $( '.primary-menu-item.is-active' );
        if ( window.innerWidth < 1024 && activeItem.length > 0 ) {
          activeItem.trigger( 'click' );
        } else if ( window.innerWidth >= 1024 && !activeItem.length ) {
          $( '.primary-menu-item' ).first().trigger( 'click' );
        }
      } );

      if ( window.innerWidth >= 1024 ) {
        $( '.primary-menu-item' ).first().trigger( 'click' );
      }

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* allows File Upload input to update name when file is uploaded */
      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload .ll-file-details' );
          $( theInput ).text( filename );
        } );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
